// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/style.min.css
// module id = 434
// module chunks = 11